import React, { useState } from 'react';
import { DatePicker, Button, Row, Col, PageHeader, notification } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import { generateCertificateIVAApi } from '../../../../api/supplier';
import { getAccesTokenApi } from '../../../../api/auth';
import { certIVAPath } from '../../../../api/config';
import { getDateDocument } from '../../../../utils/functions';

const { RangePicker } = DatePicker;

export default function VatWithholding(props) {
	const { id, setIsVisibleModal, setModalTitle, setModalContent } = props;
	const [value, setValue] = useState([]);
	const [from, setFrom] = useState('');
	const [to, setTo] = useState('');
	const [uploading, setUploading] = useState(false);
	const token = getAccesTokenApi();

	const handleChange = (value) => {
		var periodo_1 = value[0];
		var periodo_2 = value[1];
		setValue(value);
		periodo_1 !== undefined ? setFrom(periodo_1.format('YYYY-MM')) : setFrom('');
		periodo_2 !== undefined ? setTo(periodo_2.format('YYYY-MM')) : setTo('');
	};

	const GenerateCertificate = () => {
		setUploading(true);
		if (from === '' || to === '') {
			notification['error']({
				message: 'Debe seleccionar un periodo para generar certificado',
			});
			setUploading(false);
		} else {
			generateCertificateIVAApi(token, id, from, to).then((response) => {
				if (response.estado === 'OK') {
					var today = getDateDocument();
					const pdfCer = `${certIVAPath}/${response.resultado}?${today}`;
					viewCertificatePDF(pdfCer);
					setValue([], []);
					setTo('');
					setFrom('');
				} else {
					notification['error']({
						message: 'Error Generando Certificado: ' + response.resultado,
					});
				}
				setUploading(false);
			});
		}
	};

	const viewCertificatePDF = (pdfCer) => {
		//
		setModalTitle(`Consultar Certificado Retención de IVA ${id}`);
		setIsVisibleModal(true);
		setModalContent(
			<div id="imgConCert">
				<iframe id="pdfCert" src={pdfCer} style={{ width: '70vw', height: '90vw' }}></iframe>
			</div>
		);
	};

	return (
		<div>
			<PageHeader title="Certificado " subTitle=" de Retencion de IVA" />

			<Row>
				<Col span={6} className="head">
					Seleccione el periodo que desea generar el certificado:
				</Col>
				<Col span={14} className="name">
					<RangePicker
						dateRender={(current) => {
							const style = {};
							if (current.date() === 1) {
								style.border = '1px solid #1890ff';
								style.borderRadius = '50%';
							}
							return (
								<div className="ant-calendar-date" style={style}>
									{current.date()}
								</div>
							);
						}}
						locale={locale}
						placeholder={['Desde', 'Hasta']}
						format="YYYY-MM"
						value={value}
						onChange={handleChange}
					/>
				</Col>
				<Col span={4} className="head">
					<Button
						type="primary"
						onClick={GenerateCertificate}
						//disabled={disabled}
						loading={uploading}
						//style={{ marginTop: 16, marginLeft: 10 }}
					>
						{uploading ? 'Generando Certificado...' : 'Generar Certificado'}
					</Button>
				</Col>
			</Row>
		</div>
	);
}
